export const LOCAL_STORAGE_KEY_SESSION = '@ThemixPersonal/session';

// This regex is copied from following.
// https://github.com/tdegrunt/jsonschema/blob/6f6512981327c20802852fa32fa3dd4f315f7ce1/lib/helpers.js#L155
export const EMAIL_FORMAT =
  /^(?:[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+\.)*[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!\.)){0,61}[a-zA-Z0-9]?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\[(?:(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\]))$/;

export const QUERY_PARAM_CRYPTOGRAM = 'CRYPTOGRAM';
